import {Component, Vue} from "vue-property-decorator";

export class PopupWindow {
    private readonly windowInstance: Window | null;

    constructor() {
        this.windowInstance = window.open() as Window;
    }

    public setUrl(url: string) {
        if (this.windowInstance)
            this.windowInstance.location.href = url;
        else
            window.location.href = url;
    }

    // Doesnt work due to same origin policy
    // public printAndClose() {
    //     setTimeout(() => {
    //         this.print();
    //         setTimeout(() => {
    //             this.close();
    //         }, 1000);
    //     }, 1000);
    // }
    //
    // public print() {
    //     if (this.windowInstance)
    //         this.windowInstance.print();
    // }
    //
    // public close() {
    //     if (this.windowInstance)
    //         this.windowInstance.close();
    // }
}

@Component
export default class OpenerMixin extends Vue {
    public createWindow() {
        return new PopupWindow();
    }
}

